
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { EnumLogoutType, EnumAbandonType } from '@xt/client/enums'

import type { ICheckUserInfoResp } from '@xt/client/entities/my-v2/types.d'

@Observer
@Component
export default class Abandon extends Vue {
  @Prop() checkUserInfo: ICheckUserInfoResp

  get PageStore() {
    return this.$store.$storeUser
  }

  get EnumAbandonType() {
    return EnumAbandonType
  }

  get abandonCourse() {
    return this.PageStore.abandonChoose === EnumAbandonType.COURSE
  }

  confirmHandler() {
    this.PageStore.onAgreeAbandonChoose(this.PageStore.abandonChoose)
    this.PageStore.onToggleLogoutModal(EnumLogoutType.CONDITION)
  }
}
